import { render, staticRenderFns } from "./base-button.vue?vue&type=template&id=0b66b750&scoped=true"
import script from "./base-button.vue?vue&type=script&lang=ts"
export * from "./base-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66b750",
  null
  
)

export default component.exports